import React from 'react'
import bandShot from '../images/NP/IMG_5661.jpg'
import { Helmet } from 'react-helmet-async'

const Media = () => {
  return (
    <>
      <Helmet>
        <title>The Non-Prophets - Media</title>
        <meta name="description" content="Music and video." />
        <link rel="canonical" href="/media" />
      </Helmet>
      <div className="bg-slate-50 pt-20 md:pt-0">
        <header className="h-screen/3 overflow-hidden">
          <div className="relative">
            <img
              src={bandShot}
              alt="The Non-Prophets photo"
              className="w-full h-[35vh] md:h-[50vh] object-cover object-[50%_25%] opacity-50"
            />
            <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
              <h1 className="text-gray-800 text-2xl md:text-3xl tracking-widest">
                Media
              </h1>
            </div>
          </div>
        </header>

        <div className="flex justify-center p-6">
          <iframe
            style={{ borderRadius: '12px' }}
            src="https://open.spotify.com/embed/artist/2OW7NN5ZPfYuCKCiIWQOOf?utm_source=generator&si=05b3cdfed02c4954"
            width="100%"
            height="352"
            frameBorder="0"
            allowfullscreen=""
            allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
            loading="lazy"
            className="max-w-3xl"
          ></iframe>
        </div>

        {/* <div className="flex justify-center p-6 pt-0">
          <iframe
            style={{ borderRadius: '12px' }}
            src="https://open.spotify.com/embed/artist/0OajOTnmvGEgbqnH49rWAk?utm_source=generator"
            width="100%"
            height="352"
            frameBorder="0"
            allowFullScreen=""
            allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
            loading="lazy"
            className="max-w-3xl"
          ></iframe>
        </div> */}
        <div className="justify-center flex p-6 pt-0">
          <iframe
            width="100%"
            height="400"
            src="https://www.youtube.com/embed/O7pCO00YhI8?si=IFwxTV6Jl6fYt6i6"
            title="YouTube video player"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen
            className=" max-w-3xl"
          ></iframe>
        </div>

        <div className="justify-center flex p-6 pt-0">
          <iframe
            width="100%"
            height="400"
            src="https://www.youtube.com/embed/91mTcqNM0ts?is=VxYGSAnAImwUTdpN"
            title="YouTube video player"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen
            className=" max-w-3xl"
          ></iframe>
        </div>
        {/* <div className="justify-center flex p-6 pt-0">
          <iframe
            width="100%"
            height="400"
            src="https://www.youtube.com/embed/Dn-BdZm9qfQ?si=UBXWz4E1oGsSqEu6"
            title="YouTube video player"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen
            className=" max-w-3xl"
          ></iframe>
        </div>
        <div className="justify-center flex p-6 pt-0">
          <iframe
            width="100%"
            height="400"
            src="https://www.youtube.com/embed/axzP2pAyP2U?si=Y6Dh-rHCmK3oUNPo"
            title="YouTube video player"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen
            className=" max-w-3xl"
          ></iframe>
        </div>
        <div className="justify-center flex p-6 pt-0">
          <iframe
            width="100%"
            height="400"
            src="https://www.youtube.com/embed/T6x9qjRQ3yM?si=T8E3vZTJWuudsES5"
            title="YouTube video player"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen
            className=" max-w-3xl"
          ></iframe>
        </div>
        <div className="justify-center flex p-6 pt-0">
          <iframe
            width="100%"
            height="400"
            src="https://www.youtube.com/embed/UkUuNUaHXHI?si=yGbt-lWLvnxqvIcP"
            title="YouTube video player"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen
            className=" max-w-3xl"
          ></iframe>
        </div>
        <div className="justify-center flex p-6 pt-0">
          <iframe
            width="100%"
            height="400"
            src="https://www.youtube.com/embed/3X7uWaF21v0?si=ySWS027EkmkocLsT"
            title="YouTube video player"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen
            className=" max-w-3xl"
          ></iframe>
        </div>

        <div className="justify-center flex p-6 pt-0">
          <iframe
            width="100%"
            height="400"
            src="https://www.youtube.com/embed/P0k3oB0cW1w?si=ckJ-OIxv5l4VaHEL"
            title="YouTube video player"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen
            className=" max-w-3xl"
          ></iframe>
        </div> */}
      </div>
    </>
  )
}

export default Media
